import { login } from '@/api/login'
import { setToken, setRoles } from '@/utils/auth'
import { sleep } from '@/utils/timer'

export default {
  data: () => ({
    remeberMe: true,  // 记住我
    loading: false,   // 提交按钮loading状态
    userErr: '',      // 顶部错误信息
    needCaptchaCode: false, // 需要图形验证码
  }),

  computed: {
    // 登录成功后重定向的路径
    redirect: vm => vm.$route.query.redirect || process.env.VUE_APP_REDIRECT_URL,
  },

  watch: {
    remeberMe(val) {
      if (!val) {
        this.setRemberPhone('')
      }
    },
  },

  methods: {

    // 登录（短信登录 & 密码登录）
    async login(params) {
      this.loading = true
      const { data } = await login(params)

      // 登录失败
      if (!this.errorInfo(data, params)) {
        this.loading = false
        return
      }
      
      this.setRemberPhone(this.remeberMe ? this.form.telephone : '')

      // 储存用户授权信息
      const sid = data.asid || data.tsid
      setToken(sid)

      // 储存用户角色信息
      const role = data.asid ? 'admin' : 'taoke'
      setRoles([role])

      this.$message.success({ message: '登录成功', duration: 900 })

      // 等待message消失后跳转页面
      sleep(() => {
        this.loading = false

        if (this.$env.DEV) {
          console.log(this.redirect)
          this.$message.warning({ message: '登录成功，development环境下不会重定向页面', duration: 3000 })
        }
        else {
          // location.replace(decodeBase64(this.redirect)) // 重定向页面
          location.replace(this.redirect) // 重定向页面
        }
      }, 1200)

    },

    errorInfo(data, params) {
      const { error_code, error_message, need_captcha } = data

      this.userErr = ''
      this.setErr('smsErr', '')
      this.setErr('telephoneErr', '')

      if (need_captcha || error_code == 6) {
        this.needCaptchaCode = true
      }

      if (error_code == 0) {
        this.needCaptchaCode = false
        return true
      }
      // 账号或密码错误（密码登录）
      if ([1, 4].includes(error_code) && params.password != undefined) {
        this.userErr = '手机号码或密码错误'
        if(error_code == 4) {
          this.form.captcha_code = ''
          this.onRefreshImgCode()
        }
      }
      // 短信登录，手机号码错误
      else if (error_code == 1) {
        this.setErr('telephoneErr', error_message)
      }
      // 未注册
      else if (error_code == 3) {
        this.userErr = error_message
      }
      // 图片验证码错误（密码登录）
      else if (error_code == 6) {
        this.imageCodeErr = error_message
        this.form.captcha_code = ''
        this.onRefreshImgCode()
        this.setErr('imageCodeErr', error_message)
      }
      // 短信验证码错误（短信登录）
      else if (error_code == 7) {
        this.smsErr = error_message
        this.setErr('smsErr', error_message)
      }
      // 接口返回的其他错误
      else {
        this.userErr = error_message
      }

      return false
    },

    // 设置err，修复重复错误无法重复提示
    setErr(name, error_message) {
      this[name] = ' '
      this.$nextTick(() => {
        this[name] = error_message
      })
    },

    // 设置『记住我』的手机号码
    setRemberPhone(val) {
      localStorage.setItem('LOGIN_TELEPHONE', val)
    },
    // 获取『记住我』的手机号码
    getRemeberPhone() {
      return localStorage.getItem('LOGIN_TELEPHONE') || ''
    },
  },

  mounted() {
    if (!this.form.telephone) {
      this.form.telephone = this.getRemeberPhone()
    }
  }
}